function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 179 92",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("g", {
  id: "Login-Pages",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Login-Page-4",
  transform: "translate(-134 -60)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-3"
}, React.createElement("g", {
  id: "Logo",
  transform: "translate(134 60)"
}, React.createElement("path", {
  id: "Rectangle",
  fill: "#FFF",
  d: "M0 0h178.097v91.288H0z"
}), React.createElement("path", {
  id: "Rectangle",
  fill: "red",
  d: "M91.157 4.063h83.096v83.096H91.157z"
}), React.createElement("path", {
  id: "Path",
  fill: "#FFF",
  d: "M108.418 30.283h6.067v2.454h-9.222V16.483h3.155z"
}), React.createElement("path", {
  d: "M123.806 29.221h-4.075l-.909 3.516h-3.285l4.61-16.254h3.286l4.611 16.254h-3.285l-.953-3.516zm-3.428-2.486h2.782l-1.359-5.159h-.065l-1.358 5.159zM129.337 32.737V16.483h4.654a6.254 6.254 0 013.965 1.096 3.954 3.954 0 011.424 3.285 4.096 4.096 0 01-.515 2.048 3.198 3.198 0 01-1.544 1.337 3.012 3.012 0 012.026 1.303c.456.72.689 1.558.668 2.41a4.436 4.436 0 01-1.358 3.526 5.586 5.586 0 01-3.866 1.205l-5.454.044zm3.143-9.387h1.654a1.928 1.928 0 002.092-2.19 1.971 1.971 0 00-2.19-2.256h-1.512l-.044 4.446zm0 2.191v4.742h2.311a1.993 1.993 0 001.544-.58c.382-.48.57-1.086.526-1.698a2.979 2.979 0 00-.471-1.807 1.873 1.873 0 00-1.5-.668h-2.41v.011z",
  id: "Shape",
  fill: "#FFF"
}), React.createElement("path", {
  id: "Path",
  fill: "#FFF",
  d: "M150.223 25.552h-4.973v4.731h5.948v2.454h-9.102V16.483h9.08v2.465h-5.926v4.107h4.973zM156.356 30.283h6.068v2.454h-9.19V16.483h3.155zM110.345 45.321h.066l2.804-7.075h3.45l-4.754 10.47v5.805h-3.143v-6.002l-4.655-10.273h3.44z"
}), React.createElement("path", {
  d: "M129.238 48.661a6.057 6.057 0 01-1.62 4.48 6.571 6.571 0 01-8.62 0 6.046 6.046 0 01-1.61-4.48v-4.534a6.144 6.144 0 011.599-4.49 6.571 6.571 0 018.62 0 6.079 6.079 0 011.631 4.49v4.534zm-3.143-4.567a4.239 4.239 0 00-.723-2.683 2.508 2.508 0 00-2.081-.91 2.442 2.442 0 00-2.07.899 4.381 4.381 0 00-.69 2.694v4.567a4.447 4.447 0 00.69 2.717 2.859 2.859 0 004.162 0 4.38 4.38 0 00.712-2.717v-4.567z",
  id: "Shape",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M142.786 38.246V48.87a5.75 5.75 0 01-1.588 4.38 6.298 6.298 0 01-8.29 0 5.827 5.827 0 01-1.589-4.38V38.246h3.143V48.87a4.02 4.02 0 00.69 2.54 2.486 2.486 0 003.8 0c.506-.75.745-1.649.68-2.551V38.235l3.154.01z",
  id: "Path",
  fill: "#FFF"
}), React.createElement("path", {
  d: "M148.317 47.993v6.572h-3.143V38.257h4.863a5.476 5.476 0 013.822 1.226 4.512 4.512 0 011.391 3.527 3.998 3.998 0 01-.591 2.19 4.041 4.041 0 01-1.687 1.468c.766.223 1.42.728 1.829 1.413.395.756.588 1.601.559 2.453v1.194c.004.479.055.955.153 1.424.064.415.26.8.558 1.095v.241h-3.285a1.906 1.906 0 01-.493-1.172 13.253 13.253 0 01-.11-1.61v-1.095a3.067 3.067 0 00-.514-1.917 1.741 1.741 0 00-1.468-.679l-1.884-.022zm0-2.464h1.698a1.971 1.971 0 001.555-.602 2.574 2.574 0 00.526-1.73 2.837 2.837 0 00-.526-1.808 1.818 1.818 0 00-1.533-.679h-1.72v4.819zM105.263 76.294V60.02h5.017a5.367 5.367 0 014.216 1.906 7.185 7.185 0 011.665 4.94v2.683a7.152 7.152 0 01-1.665 4.895 5.4 5.4 0 01-4.216 1.895l-5.017-.044zm3.155-13.81V73.83h1.862a2.19 2.19 0 001.971-1.205c.533-.951.79-2.032.745-3.121v-2.705a5.849 5.849 0 00-.745-3.1 2.267 2.267 0 00-1.971-1.205l-1.862-.01zM125.361 72.768h-4.074l-.91 3.526h-3.285l4.622-16.275H125l4.61 16.275h-3.285l-.964-3.526zm-3.428-2.476h2.826l-1.348-5.17h-.065l-1.413 5.17z",
  id: "Shape",
  fill: "#FFF"
}), React.createElement("path", {
  id: "Path",
  fill: "#FFF",
  d: "M139.238 62.483h-3.823v13.8h-3.165v-13.8h-3.724V60.02h10.712z"
}), React.createElement("path", {
  d: "M147.112 72.768h-4.063l-.92 3.526h-3.286l4.611-16.275h3.286l4.622 16.275h-3.286l-.964-3.526zm-3.417-2.476h2.771l-1.358-5.17h-.066l-1.347 5.17z",
  id: "Shape",
  fill: "#FFF"
}), React.createElement("path", {
  id: "Path",
  fill: "red",
  d: "M54.192 69.931l7.141 4.271V64.017l-7.14-4.228z"
}), React.createElement("path", {
  id: "Rectangle",
  fill: "red",
  d: "M55.353 20.7h14.873v14.873H55.353z"
}), React.createElement("path", {
  id: "Path",
  fill: "red",
  d: "M62.867 52.834l-7.338 4.348 7.272 4.305 7.327-4.348zM21.204 72.33H35.07l-6.933-11.928z"
}), React.createElement("path", {
  d: "M87.236 4.063H4.14V87.16h83.096M52.473 17.776H73.14v20.722H52.473V17.776zM28.378 16.33c1.6-.004 3.184.32 4.654.953a1.46 1.46 0 01-1.15 2.683 8.915 8.915 0 105.41 8.204 1.468 1.468 0 012.925 0c0 6.527-5.283 11.823-11.81 11.839-6.528.016-11.837-5.254-11.869-11.781-.032-6.528 5.225-11.85 11.752-11.898h.088zM16.122 75.243L28.17 54.587l12.047 20.656H16.122zM41.783 19.56l-13.931 13.35c-.278.258-.64.402-1.019.406-.386 0-.756-.154-1.03-.427l-3.427-3.439a1.435 1.435 0 010-2.06 1.457 1.457 0 012.059 0l2.42 2.421 12.902-12.354a1.46 1.46 0 012.026 2.103zm32.595 37.972v13.23a1.457 1.457 0 01-.712 1.249l-10.098 6.035a1.424 1.424 0 01-.745.208 1.391 1.391 0 01-.493-.11h-.197l-10.065-6.024a1.49 1.49 0 01-.712-1.26V57.72a1.435 1.435 0 01.153-1.095.887.887 0 01.131-.154l.055-.065c.056-.071.119-.137.186-.197h.088l.066-.055 10.12-6.002a1.5 1.5 0 011.49 0l10.086 5.76c.554.336.818.998.647 1.622z",
  id: "Shape",
  fill: "red"
}), React.createElement("path", {
  id: "Path",
  fill: "red",
  d: "M64.258 74.224l7.184-4.293V59.767l-7.184 4.25z"
})))))));